module.exports = __webpack_public_path__ + "media/Images/icon-comment-question-o-cb1380403380f22eb2b9038a803cae54.svg";